export default __webpack_public_path__ + "static/media/gecko-terminal.5f70fe6f.svg";